import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { fetchAccounts } from "../../actions/mine_craft/accountsActions";

export interface AccountInterface {
  id: number;
  uid: string;

  user_id: number | null;
  user:    number | null;

  device_id: number;
  device:    number;

  login: boolean;
  sign_at: string | null;
  sign_out_at: string | null;

  created_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<AccountInterface>();

const slice = createSlice({
  name: 'accounts',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccounts.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.count    = action.payload.count;
        state.entities = action.payload.accounts;
        state.ids      = action.payload.ids;
        state.status   = 'succeeded';
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.status = 'failed';
        state.error  = action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;
